import React from 'react';
import ReactDOM from 'react-dom';
import Optics from 'optics';

ReactDOM.render(
  <React.StrictMode>
      <Optics />
  </React.StrictMode>,
  document.getElementById('root')
);